import axios from "axios";
import cookie from "react-cookies";

export const baseURL = "https://web-production-3590.up.railway.app/";
const getToken=()=>{
  return localStorage.getItem('token')
}
// export const getToken = () => localStorage.getItem("token")
//   ? JSON.parse(localStorage.getItem("token"))
//   : null;

let axiosTokenInstance = null
export const getAuthorization = () => {
 return  axiosTokenInstance = axios.create({
    baseURL: baseURL,
    timeout: 30000,
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: getAuthorizationHeader(),
    },
  });
}


export const getAuthorizationHeader = () => `Bearer ${getToken()}`;

export default axiosTokenInstance;
